var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"px-1",attrs:{"href":"mailto:info@zwan.it","text":"","small":"","color":"primary"}},[_vm._v(" info@zwan.it ")])}
var staticRenderFns = []

export { render, staticRenderFns }